import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useIsInViewport } from '@magento/peregrine/lib/hooks/useIsInViewport';
import { useStyle } from '@magento/venia-ui/lib/classify';
import MegaMenuItem from './megaMenuItem';
import defaultClasses from './megaMenu.module.css';
import { useMegaMenu } from './useMegaMenu';
var WHERE_TO_BUY_CATEGORY_NAME = 'Where To Buy';
/**
 * The MegaMenu component displays menu with categories on desktop devices
 */

var MegaMenu = function MegaMenu(props) {
  var _megaMenuData$childre;

  var mainNavRef = useRef(null);

  var _useMegaMenu = useMegaMenu({
    mainNavRef: mainNavRef
  }),
      megaMenuData = _useMegaMenu.megaMenuData,
      activeCategoryId = _useMegaMenu.activeCategoryId,
      subMenuState = _useMegaMenu.subMenuState,
      disableFocus = _useMegaMenu.disableFocus,
      handleSubMenuFocus = _useMegaMenu.handleSubMenuFocus,
      categoryUrlSuffix = _useMegaMenu.categoryUrlSuffix,
      handleNavigate = _useMegaMenu.handleNavigate;

  var classes = useStyle(defaultClasses, props.classes);
  var shouldRenderItems = useIsInViewport({
    elementRef: mainNavRef
  });
  var items = (_megaMenuData$childre = megaMenuData.children) === null || _megaMenuData$childre === void 0 ? void 0 : _megaMenuData$childre.map(function (category) {
    var menuItem = React.createElement(MegaMenuItem, {
      category: category,
      activeCategoryId: activeCategoryId,
      categoryUrlSuffix: categoryUrlSuffix // mainNavWidth={mainNavWidth}
      ,
      onNavigate: handleNavigate,
      key: category.id,
      subMenuState: subMenuState,
      disableFocus: disableFocus
    }); // HBF-145: Outlet sits in the primary navigation, right after Where To Buy. The Outlet
    // category itself stays out of the menu (see useMegaMenu) so it has no dropdown.

    if (category.name !== WHERE_TO_BUY_CATEGORY_NAME) return menuItem;
    return React.createElement(Fragment, {
      key: category.id
    }, menuItem, React.createElement("div", {
      className: classes.outletItem
    }, React.createElement(Link, {
      to: "/outlet",
      className: classes.outletLink,
      "aria-label": "Go to Outlet page"
    }, "Outlet")));
  });
  return React.createElement("nav", {
    ref: mainNavRef,
    className: classes.megaMenu // role="navigation"
    ,
    onFocus: handleSubMenuFocus
  }, shouldRenderItems ? items : null);
};

export default MegaMenu;